import type { RollingCounterWidget } from '../../../widgets';
import {
  BindingRow,
  NumberField,
  Row,
  Section,
  TextField,
  patcher,
  type WidgetEditorProps,
} from '../fields';

export function RollingCounterEditor(
  { widget, plantId, onChange }: WidgetEditorProps<RollingCounterWidget>,
) {
  const patch = patcher(widget, onChange);
  return (
    <>
      <Section title="Bindung">
        <BindingRow
          label="Wert-Datenpunkt"
          value={widget.valuePoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          onChange={(next) => patch({ valuePoint: next })}
        />
      </Section>
      <Section title="Anzeige">
        <Row>
          <TextField
            label="Einheit"
            value={widget.unit}
            placeholder="kWh"
            onChange={(next) => patch({ unit: next })}
          />
          <NumberField
            label="Nachkommastellen"
            value={widget.decimals}
            min={0}
            max={4}
            integer
            onChange={(next) => patch({ decimals: next })}
          />
        </Row>
        <Row>
          <NumberField
            label="Ziffernbreite"
            value={widget.digitWidth}
            min={1}
            max={12}
            integer
            hint="Reserviert Platz, damit die Kachel nicht springt, wenn eine Stelle dazukommt. 6 reicht bis 999999."
            onChange={(next) => patch({ digitWidth: next })}
          />
          <NumberField
            label="Sprungschwelle"
            value={widget.jumpThreshold}
            min={0}
            hint="Größere Sprünge werden hart gesetzt statt gerollt. Sonst läuft ein Zähler-Reset rückwärts durch jeden Zwischenwert."
            onChange={(next) => patch({ jumpThreshold: next })}
          />
        </Row>
      </Section>
    </>
  );
}
